export default {"src":"https://kroemtech.ch//_next/static/media/checklist-search.8177b970.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};